module.exports = __webpack_public_path__ + "static/media/alert.e777aad4.mp3";